import { useMemo } from "react";
import { useI18n } from "./use.i18n";

export const useSingleSelectDropdownTranslation = () => {
  const t = useI18n("BASE.DROPDOWN.");

  return useMemo(() => {
    return {
      CLEAR: t("CLEAR"),
      EXPAND: t("EXPAND"),
      COLLAPSE: t("COLLAPSE"),
      NO_OPTIONS: t("NO_OPTIONS"),
      SELECT_ALL: t("SELECT_ALL"),
      DESELECT_ALL: t("DESELECT_ALL"),
      SEARCH: t("SEARCH"),
    };
  }, [t]);
};
